// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__B7Zf2","modalForm":"UpgradeEpcsModal_modalForm__1QGao","modalFooter":"UpgradeEpcsModal_modalFooter__3qJam"};